import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MenuModule } from 'primeng/menu';
import { MenuItem, TreeNode } from 'primeng/api';
import { Users, SalesService } from 'src/app/shared/services/sales.service';

import * as $ from 'jquery';
import { Router } from '@angular/router';
import { ApplianceRole, AuthenticationService, CadenceRole } from 'src/app/services/authentication/authentication.service';


export interface NewTreeNode extends TreeNode {
  visible?: boolean;
  children?: NewTreeNode[];
}


@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  [x: string]: any;

  loading: boolean = true;
  userManagement: boolean = false;
  customerManagement: boolean = false;
  lookupManagement: boolean = false;


  visibleSidebar: boolean = false;

  // For Tree
  treeNodes: NewTreeNode[];
  selectedNode: TreeNode;
  applianceRole: ApplianceRole;
  cadenceRole: CadenceRole;



  onNodeSelect(event: any) {
    const selectedNode = event.node; // Access the selected node
    const routePath = selectedNode.data.route; // Assuming your node has a 'route' property

    if (routePath) {
      // console.log('Navigating to route:', routePath);

      this.router.navigate([routePath]);
    } else {
      // console.log('No route associated with this node.');
    }

  }



  constructor(private salesService: SalesService, private cdr: ChangeDetectorRef,
    private router: Router,
    private authenticateService: AuthenticationService) { }

  ngOnInit() {


    this.authenticateService.loginCompleted$.subscribe(() => {
      this.setupTreeNodes();
      this.cdr.detectChanges();
    });




  }

  // retriveData() {

  //   this.salesService.retrieveMainData().toPromise().then(
  //     response => {
  //       response.forEach((data, index) => {

  //         let user = <Users>data;
  //         if (user.email.toLowerCase() == sessionStorage.getItem('loginUserName').toLowerCase()) {
  //           this.userManagement = user.role.userManagement;
  //           this.customerManagement = user.role.customerManagement;
  //           this.lookupManagement = user.role.lookupManagement;



  //         }

  //       });

  //     },
  //     error => error
  //   );

  // }

  async setupTreeNodes() {

    const token = localStorage.getItem("token");



    if (token) {
      // Wait for permissions synchronously
      try {
        const roles = await this.authenticateService.getPermissions().toPromise();
        if (roles) {
          this.applianceRole = roles.applianceRole;
          this.cadenceRole = roles.cadenceRole;

          this.authenticateService.setApplanceRole(this.applianceRole);
          this.authenticateService.setCadenceRole(this.cadenceRole);
        } else {
          console.warn('Roles not found in permissions response');
        }
      } catch (error) {
        console.error('Error fetching permissions:', error);
      }
    } else {
      this.applianceRole = this.authenticateService.getApplanceRole();
      this.cadenceRole = this.authenticateService.getCadenceRole();
    }



    this.treeNodes = [
      {
      label: 'Cadence',
      icon: 'la la-bar-chart',
      children: [
        { label: 'Dashboard', visible: true, icon: 'la la-bar-chart', data: { route: '/boards' }, },
        {
        label: 'Opportunities',
        icon: 'la la-suitcase',
        data: { route: '/opportunities' },
        children: [
          {
          label: 'Won', icon: 'la la-suitcase-rolling',
          data: { route: '/opportunities/Won' },
          visible: this.cadenceRole.opportunityManagement
          },
          {
          label: 'Closed', icon: 'la la-suitcase-rolling',
          data: { route: '/opportunities/Closed' },
          visible: this.cadenceRole.opportunityManagement
          }
        ],
        visible: this.cadenceRole.opportunityManagement
        },
        {
        label: 'Add New', icon: 'la la-plus-circle', data: { route: '/leads' }
        , visible: this.cadenceRole.newOpportunityManagement
        }

      ],
      expanded: true,
      visible: this.cadenceRole.cadenceMenu
      },

      {
      label: 'Appliance',
      icon: 'fa fa-shapes',
      children: [
        { label: 'Stocks', visible: this.applianceRole.stockManagement, icon: 'fa fa-server', data: { route: '/stocks' } },
        { label: 'Orders', visible: this.applianceRole.orderManagement, icon: 'fa fa-credit-card', data: { route: '/Order' } },
        { label: 'Reports', visible: this.applianceRole.inventoryManagement, icon: 'pi pi-file', data: { route: '/inventory' } },
        { label: 'Customer Orders', visible: this.applianceRole.stockManagement, icon: 'fa fa-credit-card', data: { route: '/customer-orders' } },

      ], expanded: true,
      visible: this.applianceRole.stockManagement || this.applianceRole.orderManagement || this.applianceRole.inventoryManagement
      },
      { label: 'File Processing', visible: this.applianceRole.fileProcessingManagement, icon: 'fa fa-file', data: { route: '/file-processing' } },
      {
      label: 'RFP',
      icon: 'fa fa-file-signature',
      visible: this.applianceRole.RFPManagement,
      children: [
        { label: 'Management', icon: 'fa fa-file-signature', data: { route: '/rfp' } },
        { label: 'Dashboard', icon: 'la la-bar-chart', data: { route: '/rfp-dashboard' } }
      ],
      expanded: true
      },
      {
      label: 'Prospects',
      icon: 'fa fa-file-contract',
      visible: this.applianceRole.prospectsManagement,
      children: [
        { label: 'Management', icon: 'fa fa-file-contract', data: { route: '/prospects' } },
        { label: 'Dashboard', icon: 'la la-bar-chart', data: { route: '/prospect-dashboard' } }
      ],
      expanded: true
      },
      {
      label: 'Settings', icon: 'la la-gear',
      data: { route: 'boards' },
      children: [
        {
        label: 'Users', icon: 'la la-user',
        data: { route: '/usermgmt' },
        visible: this.cadenceRole.userManagement
        },
        {
        label: 'Customers', icon: 'fa fa-users',
        data: { route: '/customermgmt' },
        visible: this.cadenceRole.customerManagement
        },
        {
        label: 'Lookup ', icon: 'la la-gear',
        data: { route: '/lookupmgmt' },
        visible: this.cadenceRole.lookupManagement
        },

      ], expanded: true,
      visible: this.cadenceRole.userManagement || this.cadenceRole.customerManagement || this.cadenceRole.lookupManagement
      }

    ];


    this.treeNodes = this.getValidTreeNodeItems(this.treeNodes);
    this.loading = false;
  }


  getValidTreeNodeItems(treeNodes: NewTreeNode[]): NewTreeNode[] {
    const validItem = treeNodes.filter(i => i.visible !== false);

    validItem.forEach(i => {
      if (i.children) {
        i.children = this.getValidTreeNodeItems(i.children);
      }
    });

    return validItem;
  }

  items: MenuItem[];
  settingClass = "hide-class";
  opportunitiesClass = "hide-class";

  toggleSubMenu(event) {

    $(".collapsed").css("background-color", "transparent");
    event.target.style.backgroundColor = '#3F51B5';

    //console.log(event);
    // console.log(event.target.id);
    if (event.target.id == "dashboardLink" || event.target.id == "leadsLink") {
      this.settingClass = "hide-class";
      this.opportunitiesClass = "hide-class";
    } else if (event.target.id == "settingsLink") {
      if (this.settingClass == "hide-class") {
        this.settingClass = "show-class";
      }
      else {
        this.settingClass = "hide-class";
      }
    } else if (event.target.id == "oppLink") {
      if (this.opportunitiesClass == "hide-class") {
        this.opportunitiesClass = "show-class";
      }
      else {
        this.opportunitiesClass = "hide-class";
      }
    }

  }




}
